import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {withRouter} from 'react-router-dom';
import {v4 as uuid} from 'uuid';

import {withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  CustomButton,
  CustomInput,
} from '../../material-dashboard-pro-react/components/index';

import {
  RenderOrEmpty,
  SectionLinkInUnauthForm,
} from '../index';

import {
  ROUTES,
} from '../../constants';

import {
  Visibility,
  VisibilityOff,
} from '../../icons/index';

import style from './style';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      showPassword: false,
      submitDisabled: true,
    };
  }

  onChange = (e) => {
    const newState = {
      ...this.state,
      [e.target.name]: e.target.value,
    };
    const isValid = this.validate(newState);
    this.setState({
      ...newState,
      submitDisabled: !isValid,
    });
  };

  onSubmit = () => {
    const {
      password,
      username,
    } = this.state;
    this.props.login(
      {
        name: username.toLowerCase(),
        password: password,
      },
      this.props.history,
    );
  };

  validate = (data) => {
    const isNotEmpty = (str) => !!str;
    const validatingRules = [
      {
        name: 'username',
        validatingRules: [isNotEmpty],
      },
      {
        name: 'password',
        validatingRules: [isNotEmpty],
      },
    ];

    return validatingRules.reduce(
      (result, rule) => {
        const value = data[rule.name];
        return result && rule.validatingRules.reduce(
          (_result, func) => _result && func(value),
          true,
        );
      },
      true,
    );
  };

  handleMouseDownPassword = (e) => {
    e.preventDefault();
  };

  showHidePassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  render() {
    const {
      password,
      showPassword,
      submitDisabled,
      username,
    } = this.state;

    const {
      classes,
      isLoggedInFailed,
    } = this.props;

    const propsInput = {
      username: {
        value: username,
        name: 'username',
        onChange: this.onChange,
        type: 'text',
        onBlur: () => this.setState((prevState) => ({username: prevState.username.trim()})),
      },
      password: {
        value: password,
        name: 'password',
        onChange: this.onChange,
        type: showPassword ? 'text' : 'password',
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={this.showHidePassword}
              onMouseDown={this.handleMouseDownPassword}
            >
              {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        onBlur: () => this.setState((prevState) => ({password: prevState.password.trim()})),
      },
    };
    const propsFormControl = {
      fullWidth: true,
    };

    return (
      <>
        <RenderOrEmpty isShow={isLoggedInFailed}>
          <div className={classes.loginForm__errorMessage}>
            {I18n.t('loginPage.errorMessageLoginFailed')}
          </div>
        </RenderOrEmpty>
        <CustomInput
          labelText={I18n.t('loginPage.username')}
          id={uuid()}
          formControlProps={propsFormControl}
          inputProps={propsInput.username}
        />
        <CustomInput
          labelText={I18n.t('loginPage.password')}
          id={uuid()}
          formControlProps={propsFormControl}
          inputProps={propsInput.password}
        />
        <p>
          By logging in you agree to the ‎
          <a href="https://www.scoutdns.com/terms-and-conditions/">
            Terms and Conditions.
          </a>
        </p>
        <CustomButton
          fullWidth={true}
          disabled={submitDisabled}
          color="secondary"
          customClasses="unauthorizedForm__button"
          onClick={this.onSubmit}
        >
          {I18n.t('loginPage.login')}
        </CustomButton>
        <SectionLinkInUnauthForm
          text={I18n.t('loginPage.forgotPassword')}
          to={ROUTES.RESET_PASSWORD}
        />
      </>
    );
  }
}

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  isLoggedInFailed: PropTypes.bool.isRequired,
};

LoginForm.defaultProps = {};

export default withRouter(withStyles(style)(LoginForm));
